import { Translate } from 'react-redux-i18n'
import { Panel } from '../../../../common/panel'
import { Label } from '../Label'
import { Content } from './Content'
import { ValidateYear } from './ValidateYear'

export const FinancialStatement = () => {
  return (
    <Panel
      renderLabel={() => (
        <Label
          label={'companyAnalysis.peerAnalysis.FINANCIAL_STATEMENT'}
          renderToolTipContent={() => (
            <div className="flexColumn">
              <Translate value="companyAnalysis.peerAnalysis.FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_1" />
              <Translate value="companyAnalysis.peerAnalysis.FINANCIAL_STATEMENT_TOOLTIP_DISCLAIMER_2" />
            </div>
          )}
        />
      )}
    >
      <ValidateYear>
        <Content />
      </ValidateYear>
    </Panel>
  )
}
